// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "YEAR IN REVIEW",
    "note": "*All statistics in this review are as of 2025/12/31."
  },
  "handCard": {
    "text": "{date}\nYou played NUTS POKER for the first time in 2025."
  },
  "report": {
    "loginTime": "Since then, \nNUTS POKER has accompanied you through \n{loginDay}",
    "loginTips": "*Days logged into NUTS POKER in 2025.",
    "enjoyTime": "{loginTime}\nis the most enjoyable time of the day for you! This is your favorite time to open NUTS POKER!",
    "firstHandDate": "{first_hand_date}\nYou received your first hand of the year playing {first_hand_type}.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "This year in NUTS POKER,\nyou played a total of\n{hands}\nYour love for poker surpassed \n{percentage} of players.",
    "v2": "This year in NUTS POKER,\nyou played a total of\n{hands}\nThank you for being part of our journey!",
    "v3": "This year in NUTS POKER,\nyou played a total of \n{hands}\nNUTS POKER will strive to improve and give you an even more enjoyable experience next year."
  },
  "hardTime": {
    "date": "{one_day_hands}\nThis was your most dedicated day on NUTS POKER.",
    "hands": "That day, you played a total of\n{one_day_hands_num} {longHands}"
  },
  "favoriteGame": "Out of your total number of hands,\n{handsNum} {hands} were played \nin your favorite game format {game}.",
  "kkWin": {
    "v1": "In 2025, you obtained KK a total of\n{all} {longTimes}\nand defeated your opponents with KK\n{win} {longTimesTwo}",
    "v2": "This year, you went all-in\n{all} {threeTimes}\nYour All-in Win Rate:\n{percentage}\nPoker is a game for the fearless!"
  },
  "achievement": {
    "spinup": "{spinup_date}\nIt was your luckiest day!",
    "spinup_2": "That day,\nyou hit the {spinup_ratio} multiplier in SpinUp\nand won\n{spinup_reward}",
    "mtt": "{mtt_date}\nIt was the highlight of your year.",
    "mtt_2": "That day,\nyou ranked {no} {mtt_rank} in {mtt_name}\nand won\n{mtt_reward}",
    "rg": "{rg_date}\nA remarkable day in your poker journey!",
    "rg_2": "That day,\nyou won your biggest pot of the year:\n{rg_reward}"
  },
  "lucky": {
    "title": "Every hand tells\na different story.",
    "luckyHand": "LUCKY\nHAND",
    "unLuckyHand": "UNLUCKY\nHAND",
    "luckyRate": "Win Rate\n {lucky_rate}",
    "unLuckyRate": "Win Rate\n{unlucky_rate}",
    "luckyText": "{lucky_hand} has played the hero. \nYou won {lucky_rate} of the time when you had it with you!",
    "unLuckyText": "Watch out for {unlucky_hand}...\nYou only won {unlucky_rate} of the time with it.",
    "note": "*Only starting hands dealt 10 times or more are eligible."
  },
  "futureStory": "NUTS POKER can’t wait to keep writing the story of your poker journey with you in 2026!",
  "version3": {
    "text": "Unfortunately, you didn’t leave any memories with NUTS POKER in 2025.",
    "continue": "Come write the next chapter\nof your NUTS POKER journey in 2026!",
    "tips": " *All statistics are as of 2024-12-31."
  },
  "button": {
    "save": "Save Image",
    "copy": "Copy and Share"
  },
  "unit": {
    "days": "days",
    "hands": "hands",
    "longHands": "hands",
    "longTimes": "times",
    "longTimesTwo": "times",
    "threeTimes": "times",
    "times": "times",
    "multiplier": "multiplier",
    "num": "No.",
    "num2": "",
    "bets": "bets",
    "skUnits": "of players"
  },
  "toast": {
    "linkCopied": "Link copied",
    "imageSaved": "Image saved"
  }
}
  